import axios, { type AxiosError } from "axios";
import { env } from "@/config/env";
import { parseApiErrorBody } from "./parseApiErrorMessage";

function errorMessageFromAxiosError(error: AxiosError): string {
  const status = error.response?.status ?? 0;
  const statusText = error.response?.statusText ?? "Error";
  const fallback = `Request failed: ${status} ${statusText}`;
  return parseApiErrorBody(error.response?.data, fallback);
}

/** Axios client for auth endpoints (no Bearer / refresh interceptors). */
export const authHttp = axios.create({
  baseURL: env.apiBaseUrl || undefined,
  withCredentials: true,
  headers: {
    Accept: "application/json",
  },
});

authHttp.interceptors.response.use(
  (response) => response,
  (error: unknown) => {
    if (!axios.isAxiosError(error)) {
      return Promise.reject(error);
    }

    return Promise.reject(new Error(errorMessageFromAxiosError(error)));
  },
);
